<template>
  <div class="enterprise-list-page enterprise-list-page--crm-deposit">

    <!-- Header Card -->
        <PageHeader icon="fas fa-wallet">
      <template #title>
        Pengingat Deposit {{ clinic_name }}
      </template>
      <template #subtitle>
        Jaga nilai deposit pasien dengan pengingat masa berlaku dan sisa layanan yang tepat waktu
      </template>
    </PageHeader>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table purpose="master" :source="0" />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Table from '@/component/masters/payment-categories/TableUsedItemReminder.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Table
  },

  data() {
    return {
      btn: false,
      btnAddDoctorCommission: false,
      clinic_name : window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  methods: {

    setActiveButton() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "6009") {
          this.btn = true
        }        
      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Customer Relationship", },
      { title: "Pengingat Deposit" },
    ])
    this.setActiveButton()
  },

}

</script>
